import theme from 'theme';

import {
  Button as MUIButton,
  ButtonProps,
  CircularProgress,
  CircularProgressProps,
} from '@mui/material';

interface Props extends ButtonProps {
  loading?: boolean;
  circularProgressProps?: CircularProgressProps;
}

export const Button: React.FC<Props> = ({
  children,
  sx,
  variant = 'contained',
  loading,
  circularProgressProps,
  ...props
}) => {
  return (
    <MUIButton
      variant={variant}
      {...props}
      sx={{
        color: variant !== 'contained' ? theme.palette.primary.main : '#FFF',
        ...sx,
      }}
    >
      {children}

      {loading && (
        <CircularProgress
          size="small"
          {...circularProgressProps}
          sx={{ width: 24, height: 24, ml: 2, ...circularProgressProps?.sx }}
        />
      )}
    </MUIButton>
  );
};

